import styled from '@emotion/styled'
import { Select as MaterialSelect } from 'ui-components/Select'

export const Select = styled(MaterialSelect)`
  padding-bottom: 20px;
  margin-right: 20px;
`
